import { Alert, Container, Divider, Paper, Snackbar, Stack, styled, Typography } from '@mui/material';
import { useState } from 'react';
import TeamCreateForm from '../../components/TeamManagement/TeamCreateForm.tsx';
import TeamsTable from '../../components/TeamManagement/TeamsTable.tsx';

const TextWrapper = styled('div')({
  gridColumn: '1/5',
});

const ContentWrapper = styled('div')({
  gridColumn: '6/13',
});

function TeamManagement() {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'error'>('success');

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const showSnackbar = (message: string, severity: 'success' | 'error') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  return (
    <>
      <Container sx={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr);', gap: 8 }}>
        <TextWrapper>
          <Typography
            variant='h5'
            sx={{
              fontWeight: 'bold',
            }}
          >
            Create team
          </Typography>
          <Typography
            variant='body2'
            sx={{
              color: 'text.secondary',
              marginTop: 2,
            }}
          >
            Enter the team details and select county to create a new team.
          </Typography>
        </TextWrapper>
        <ContentWrapper>
          <Stack
            component={Paper}
            sx={{
              padding: 3,
              border: '1px solid #cbd5e0',
              boxShadow: 'none',
              height: '100%',
            }}
          >
            <TeamCreateForm snackbarData={showSnackbar} />
          </Stack>
        </ContentWrapper>
      </Container>
      <Container>
        <Divider sx={{ marginY: 6 }} />
      </Container>
      <Container sx={{ marginBottom: 10, display: 'flex', flexDirection: 'column', gap: 4 }}>
        <TextWrapper>
          <Typography
            variant='h5'
            sx={{
              fontWeight: 'bold',
            }}
          >
            Manage teams
          </Typography>
          <Typography
            variant='body2'
            sx={{
              color: 'text.secondary',
              marginTop: 2,
            }}
          >
            View, edit or delete existing teams. Use the actions menu to manage each team.
          </Typography>
        </TextWrapper>
        <TeamsTable snackbarData={showSnackbar} />
      </Container>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}

export default TeamManagement;
